import { Fragment } from 'react'
import Hero4 from '../../components/hero4/hero4'
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation'
// import PartnerSection from '../../components/PartnerSection/PartnerSection'
import Footer from '../../components/footer/Footer'
import ProjectSection from '../../components/ProjectSection/ProjectSection'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo-2.png'

const ProjectPage = () => {
  return (
    <Fragment>
      <Navbar
        hclass={'wpo-site-header wpo-header-style'}
        Logo={Logo}
        col1={'col-lg-3 col-md-1 col-2 d-lg-none dl-block'}
         col2={'col-lg-4 col-md-11 col-10'}
        col3={'col-lg-8 col-md-1 col-1'}
        col4={'col-lg-2 col-md-2 col-2'}
      />
      <Hero4 />
      <PageTitle pageTitle={''} pagesub={'Construction Materials'} />
      <ScrollTextAnimation />
      <ProjectSection
        hclass={'wpo-project-section title section-padding pt-0'}
      />
      {/* <PartnerSection hclass={'wpo-partners-section fade_bottom'} /> */}
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}
export default ProjectPage
